<template>
  <campaigns-list status="scheduled" />
</template>

<script>
import CampaignsList from '@/modules/campaigns/components/CampaignsList'
export default {
  name: 'ScheduledCampaignsTab',
  components: { CampaignsList }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/campaigns/components/ScheduledCampaignsTab.vue